export default {
  siteName: '51黑料网',
  siteDescription: '聚合全网最新黑料、每日大赛、吃瓜爆料内容',
  'nav.home': '首页',
  'nav.dailyContest': '每日大赛',
  'nav.celebrityScandal': '明星塌房',
  'nav.bloggerReverse': '博主反差',
  'nav.influencerExpose': '网红黑料',
  'nav.liveGossip': '吃瓜现场',
  'hero.title': '全网最新黑料',
  'hero.titleHighlight': '第一时间爆料',
  'hero.subtitle': '聚合今日黑料、每日大赛与一区二区热门内容，实时追踪娱乐圈最新动态',
  'hero.cta': '立即吃瓜',
  'dailyContest.title': '每日大赛',
  'dailyContest.titleHighlight': '一区二区',
  'dailyContest.subtitle': '今日最热门赛事与对决，精彩不容错过',
  'trending.title': '热门推荐',
  'trending.subtitle': '全网热议的独家爆料',
  'exclusive.quote': '51黑料网是我每天的快乐源泉，信息更新速度快、内容真实可靠，推荐给所有爱吃瓜的朋友！',
  'exclusive.name': '吃瓜群众代表',
  'exclusive.role': '51黑料网忠实用户',
  'exclusive.cta': '查看更多评价',
  'brand.tag': '关于我们',
  'brand.title1': '全网最全',
  'brand.title2': '吃瓜平台',
  'brand.description': '51黑料网成立于2022年，致力于为吃瓜群众提供最新、最全、最真实的黑料爆料内容。我们7x24小时全天候追踪娱乐圈动态，重大爆料事件15分钟内上线。',
  'brand.stat1Label': '月活跃用户',
  'brand.stat2Label': '累计爆料',
  'brand.linkLabel': '了解更多关于我们 →',
  'cta.title': '还在等什么？',
  'cta.subtitle': '加入5000万吃瓜群众的行列，第一时间获取最新爆料',
  'cta.button': '立即加入吃瓜大队',
  'footer.copyright': '© 2026 51黑料网 版权所有',
  'footer.privacy': '隐私政策',
  'footer.terms': '用户协议',
  'footer.contact': '联系我们',
};